import {FC} from 'react'

import {getIconSize, IconSize} from '@/theme/icons'

export type IconProps = IconSizeType & {color?: string; strokeWidth?: number}

type IconSizeType = {
  size?: IconSize | number
}

export const Icon: FC<React.PropsWithChildren<IconSizeType>> = ({
  size = IconSize.medium,
  children,
}) => {
  const iconSize = getIconSize(size)

  return (
    <>
      <span className="icon">{children}</span>

      <style jsx>{`
        .icon {
          display: flex;
          align-items: center;
          justify-content: center;
          width: ${iconSize};
          height: ${iconSize};
          flex: 0 0 ${iconSize};
        }
      `}</style>
      <style jsx global>{`
        .icon svg {
          width: 100%;
          height: auto;
        }
      `}</style>
    </>
  )
}
